import * as React from 'react';

export interface IKbdHintProps {
  children: React.ReactNode;
}

/** A key cap that teaches a shortcut inline, inside a control's label or placeholder. */
const KbdHint = ({ children }: IKbdHintProps) => (
  <kbd className="border-border-primary bg-bg-primary text-fg-tertiary mx-0.5 inline-block rounded-sm border px-1 py-px font-mono text-[10px] leading-none">
    {children}
  </kbd>
);

export default KbdHint;
